import { motion } from "framer-motion";

/**
 * Art deco ornament: line — diamond — line
 * Used as subtle section dividers.
 */
const Ornament = ({ className = "" }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scaleX: 0.6 }}
      whileInView={{ opacity: 1, scaleX: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
      data-testid="ornament"
      className={`flex items-center justify-center gap-4 ${className}`}
      aria-hidden="true"
    >
      <div className="h-px w-16 md:w-24 bg-gradient-to-r from-transparent to-gold-500/50" />
      <svg width="14" height="14" viewBox="0 0 14 14" className="text-gold-500">
        <path d="M7 1 L13 7 L7 13 L1 7 Z" fill="none" stroke="currentColor" strokeWidth="1" />
        <circle cx="7" cy="7" r="1.2" fill="currentColor" />
      </svg>
      <div className="h-px w-16 md:w-24 bg-gradient-to-l from-transparent to-gold-500/50" />
    </motion.div>
  );
};

export default Ornament;
